// Alternative approach: Add a temporary global status item, make default same as Rebuy.SmartCart.status
window.cartStatus = {
  current: null,
  set: function(status) {
    this.current = status;
  },

  clear: function() {
    this.current = null;
  }
};

document.addEventListener('rebuy:smartcart.item-switch-to-one-time', function(event) {
  if (event.detail.item) handleSubscriptionToOTPDowngrade(event.detail.item);
});


// Main entry point - called by Rebuy's frequency selector
window.customUpdateFrequency = function(item) {
  const newFrequency = item.product?.subscription_frequency || 'onetime';

  // Enhanced selling plan detection - check multiple sources
  const hasSellingPlan = !!(
    item.selling_plan ||
    item?.selling_plan_allocation?.selling_plan?.id ||
    item?.sellingPlanAllocation?.sellingPlan?.id ||
    (item.properties && (item.properties.selling_plan || item.properties._selling_plan)) ||
    (item.product?.subscription && item.product.subscription === true)
  );

  // check if it HAS the _otp property
  const isCurrentlyOTP = item.properties?._otp;
  const isTargetOTP = newFrequency === 'onetime' && !hasSellingPlan;

  if (!isCurrentlyOTP && !isTargetOTP) {
    // Subscription → Subscription (frequency change) - for items without selling plan yet
    handleSubscriptionFrequencyChange(item, newFrequency);
  }
};

// Handle OTP item with selling plan - convert to proper subscription
window.handleOTPWithSellingPlanConversion = function(item) {
  // Set converting status for UI feedback
  item.status = 'upgrading';
  window.cartStatus.set('upgrading');
  console.log(item.status);
  console.log('handleOTPWithSellingPlanConversion', item);

  // Extract selling plan information - find the one with the biggest number in the name
  let sellingPlanId = null;
  let sellingPlanInfo = null;

  if (item.selling_plan) {
    sellingPlanId = item.selling_plan;
  } else if (item.selling_plan_allocation?.selling_plan?.id) {
    sellingPlanId = item.selling_plan_allocation.selling_plan.id;
    sellingPlanInfo = item.selling_plan_allocation.selling_plan;
  } else if (item.sellingPlanAllocation?.sellingPlan?.id) {
    sellingPlanId = item.sellingPlanAllocation.sellingPlan.id;
    sellingPlanInfo = item.sellingPlanAllocation.sellingPlan;
  } else {
    // Item doesn't have a selling plan - find the one with the biggest number in the name
    const bestSellingPlan = findSellingPlanWithBiggestNumber(item.product);
    if (bestSellingPlan) {
      sellingPlanId = bestSellingPlan.id;
      sellingPlanInfo = bestSellingPlan;
      console.log('Found selling plan with biggest number:', bestSellingPlan.name, 'ID:', sellingPlanId);
    }
  }

  // Determine target months from selling plan (default to 3 for upgrades)
  let targetMonths = 3;
  if (sellingPlanInfo) {
    const extractedMonths = extractMonthsFromSellingPlan(sellingPlanInfo);
    if (extractedMonths) {
      targetMonths = extractedMonths;
    }
  }

  // Find the appropriate subscription variant for the target months
  let targetVariant = findSubscriptionVariant(item.product, targetMonths);

  // If no specific variant found, try highest tier subscription variant
  if (!targetVariant) {
    targetVariant = findHighestTierSubscriptionVariant(item.product);
  }

  // Fallback: use current variant if it's not obviously OTP
  if (!targetVariant) {
    const currentVariantTitle = item.product?.variants?.find(v => v.id === item.variant_id)?.title || 'Unknown';
    const isCurrentVariantOTP = currentVariantTitle.toLowerCase().includes('one time') ||
      currentVariantTitle.toLowerCase().includes('onetime') ||
      currentVariantTitle.toLowerCase().includes('time purchase');

    if (!isCurrentVariantOTP) {
      targetVariant = item.product?.variants?.find(v => v.id === item.variant_id);
    }
  }

  // Last resort: use highest tier variant
  if (!targetVariant) {
    targetVariant = findHighestTierVariant(item.product);
  }

  if (!targetVariant) {
    console.error('❌ No suitable variant found for subscription conversion');
    item.status = null;
    return;
  }

  // Convert OTP item to subscription with proper variant
  convertOTPToSubscription(item, targetVariant, sellingPlanId, targetMonths);
};

// Convert OTP item to subscription with variant swap if needed
function convertOTPToSubscription(currentItem, targetVariant, sellingPlanId, targetMonths) {
  currentItem.status = 'upgrading';
  window.cartStatus.set('swap');
  // Prepare subscription properties
  const subscriptionProperties = { ...currentItem.properties };
  delete subscriptionProperties._otp; // Remove OTP flag
  subscriptionProperties._months = targetMonths.toString();
  // If same the variant, just update properties and selling plan
  if (targetVariant.id === currentItem.variant_id) {
    currentItem.status = 'upgrading';

    const updateData = {
      id: targetVariant.id,
      quantity: currentItem.quantity,
      properties: subscriptionProperties
    };

    // Check selling plan compatibility before adding
    if (sellingPlanId && targetVariant.selling_plan_allocations?.some(allocation =>
      allocation.selling_plan_id?.toString() === sellingPlanId.toString())) {
      updateData.selling_plan = sellingPlanId;
    }

    console.log('updateData', updateData);

    window.Rebuy.Cart.changeItem(currentItem, updateData, function(success) {
      // Update product object to reflect subscription state
      if (currentItem.product) {
        currentItem.product.subscription = true;
        currentItem.product.subscription_frequency = sellingPlanId;
      }
      console.log('success', success);
      currentItem.status = null;
      window.cartStatus.clear();
    }, function(error) {
      console.error('❌ Failed to convert OTP to subscription:', error);
    });

  } else {
    currentItem.status = 'upgrading';
    window.cartStatus.set('swap');
    // Different variant - need to swap variant AND convert to subscription
    window.Rebuy.Cart.removeItem(currentItem, function() {
      const newItemData = {
        id: targetVariant.id,
        quantity: currentItem.quantity,
        properties: subscriptionProperties
      };

      // Check selling plan compatibility before adding
      if (sellingPlanId && targetVariant.selling_plan_allocations?.some(allocation =>
        allocation.selling_plan_id?.toString() === sellingPlanId.toString())) {
        newItemData.selling_plan = sellingPlanId;
      }

      window.Rebuy.Cart.addItem(newItemData, {
        success: function(response) {
          currentItem.status = null;
          window.cartStatus.clear();
        },
        error: function(error) {
          console.error('❌ Failed to add subscription variant:', error);

          // Restore original item
          window.Rebuy.Cart.addItem({
            id: currentItem.variant_id,
            quantity: currentItem.quantity,
            properties: currentItem.properties,
            selling_plan: currentItem.selling_plan
          }, {
            success: function() {
              currentItem.status = null;
              window.cartStatus.clear();
            },
            error: function(restoreError) {
              console.error('❌ Failed to restore original item:', restoreError);
              currentItem.status = null;
              window.cartStatus.clear();
            }
          });
        }
      });
    }, function(removeError) {
      console.error('❌ Failed to remove OTP item:', removeError);
      currentItem.status = null;
      window.cartStatus.clear();
    });
  }
}

// Check if subscription item is on OTP variant and needs variant swap
function handleSubscriptionVariantCheck(item, frequency) {
  // Check if current variant is an OTP variant that needs swapping
  const currentVariant = item.product?.variants?.find(v => v.id === item.variant_id);
  const variantTitle = currentVariant?.title?.toLowerCase() || '';

  const isOnOTPVariant = variantTitle.includes('one time') ||
    variantTitle.includes('onetime') ||
    variantTitle.includes('one-time') ||
    variantTitle.includes('time purchase');

  // If already on a good subscription variant, no need to swap
  if (!isOnOTPVariant) {
    return;
  }

  // Default to 3 months for subscription upgrades
  const targetMonths = 3;

  // Find the best subscription variant for 3 months
  let targetVariant = findSubscriptionVariant(item.product, targetMonths);

  // If no specific subscription variant found, try to find highest tier subscription variant
  if (!targetVariant) {
    targetVariant = findHighestTierSubscriptionVariant(item.product);
  }

  // Fallback: use highest tier variant (any type)
  if (!targetVariant) {
    targetVariant = findHighestTierVariant(item.product);
  }

  if (!targetVariant || targetVariant.id === item.variant_id) {
    return;
  }

  // Perform variant swap - item already has subscription properties from Rebuy
  swapToSubscriptionVariant(item, targetVariant);
}

// Handle variant update after Rebuy has successfully switched to subscription
function handleVariantUpdateAfterSubscriptionSwitch(item) {
  // Default to 3 months for OTP upgrades
  const targetMonths = 3;

  // Check if current variant is appropriate for subscription
  const currentVariant = item.product?.variants?.find(v => v.id === item.variant_id);
  const variantTitle = currentVariant?.title?.toLowerCase() || '';

  const isOnOTPVariant = variantTitle.includes('one time') ||
    variantTitle.includes('onetime') ||
    variantTitle.includes('time purchase');

  // If already on a good subscription variant, no need to swap
  if (!isOnOTPVariant) {
    return;
  }

  // Find the best subscription variant for 3 months
  let targetVariant = findSubscriptionVariant(item.product, targetMonths);

  // If no specific subscription variant found, try to find highest tier subscription variant
  if (!targetVariant) {
    targetVariant = findHighestTierSubscriptionVariant(item.product);
  }

  // Fallback: use highest tier variant (any type)
  if (!targetVariant) {
    targetVariant = findHighestTierVariant(item.product);
  }

  if (!targetVariant || targetVariant.id === item.variant_id) {
    return;
  }

  // Perform variant swap - item already has subscription properties from Rebuy
  swapToSubscriptionVariant(item, targetVariant);
}

// Swap to subscription variant (item already converted to subscription by Rebuy)
function swapToSubscriptionVariant(currentItem, targetVariant) {
  // Set updating status for UI feedback
  currentItem.status = 'upgrading';
  window.cartStatus.set('swap');

  // Prepare subscription properties - item is already a subscription, just update _months
  const subscriptionProperties = { ...currentItem.properties };
  delete subscriptionProperties._otp; // Ensure no OTP flag
  subscriptionProperties._months = '3'; // Default to 3 months for subscription upgrades

  // Remove current item and add new variant with subscription properties
  window.Rebuy.Cart.removeItem(currentItem, function() {
    const newItemData = {
      id: targetVariant.id,
      quantity: currentItem.quantity,
      properties: subscriptionProperties,
      selling_plan: currentItem.selling_plan // Keep existing selling plan from Rebuy
    };

    window.Rebuy.Cart.addItem(newItemData, {
      success: function(response) {
        // Clear updating status on original item reference
        currentItem.status = null;
      },
      error: function(error) {
        console.error('❌ Failed to add subscription variant:', error);

        // Re-add original item as last resort
        window.Rebuy.Cart.addItem({
          id: currentItem.variant_id,
          quantity: currentItem.quantity,
          selling_plan: currentItem.selling_plan,
          properties: currentItem.properties
        }, {
          success: function() {
            currentItem.status = null;
          },
          error: function(restoreError) {
            console.error('❌ Failed to restore original item:', restoreError);
            currentItem.status = null;
          }
        });
      }
    });
  }, function(removeError) {
    console.error('❌ Failed to remove original item for variant swap:', removeError);
    currentItem.status = null;
  });
}

// Handle Subscription to OTP downgrade
function handleSubscriptionToOTPDowngrade(item) {
  // Set item status to "downgrading" immediately
  item.status = 'downgrading';

  // Find the basic OTP variant (not based on subscription months!)
  let otpVariant = findBasicOTPVariant(item.product);

  // If no OTP variant found, use current variant but ensure OTP properties
  if (!otpVariant) {
    otpVariant = item.product.variants?.find(v => v.id === item.variant_id);
  }

  if (otpVariant && otpVariant.id !== item.variant_id) {
    swapVariantAndFrequency(item, otpVariant, 'onetime');
  } else if (otpVariant) {
    // Update properties for OTP - remove _months and set _otp flag
    const updatedProperties = {
      ...item.properties,
      _otp: 'true'
    };

    // Remove _months property for OTP items
    delete updatedProperties._months;

    // Use changeItem to update properties and remove selling plan
    window.Rebuy.Cart.changeItem(item, {
      properties: updatedProperties,
      selling_plan: null // Remove selling plan for OTP
    }, function(success) {
      // Ensure the item is now marked as OTP in Rebuy's system
      if (item.product) {
        item.product.subscription = false;
        item.product.subscription_frequency = null;
      }

      // Status will be automatically cleared by Smart Cart event listeners
      // 'rebuy:smartcart.item-switch-to-one-time' event will handle status clearing

    }, function(error) {
      console.error('❌ Failed to update item to OTP using changeItem:', error);

      // Fallback: try native Rebuy downgrade
      window.Rebuy.Cart.switchToOneTime(item, function(success) {
        // Status clearing will be handled by Smart Cart events if successful
        // Update properties after successful downgrade - OTP removes _months
        updateItemProperties(item, 'onetime', null);

        // Fallback status clearing after delay
        setTimeout(() => {
          if (item.status === 'downgrading') {
            item.status = null;
          }
        }, 3000);
      }, function(nativeError) {
        console.error('❌ Native OTP downgrade also failed:', nativeError);
        item.status = null; // Clear downgrading status immediately on error
      });
    });
  } else {
    console.error('❌ No variant found for OTP downgrade');
    item.status = null; // Clear downgrading status
  }
}

// Handle Subscription frequency changes
function handleSubscriptionFrequencyChange(item, newFrequency) {
  // Set status for UI feedback
  item.status = 'upgrading';
  window.cartStatus.set('swap');

  // Parse frequency number from selling plan
  const frequencyNumber = getMonthsFromFrequency(newFrequency, item);
  if (!frequencyNumber) {
    item.status = null;
    return;
  }

  // Flexible matching as fallback
  const targetVariant = findVariantFlexible(item.product, frequencyNumber, newFrequency);

  // Get new selling plan for the frequency
  const newSellingPlan = getSellingPlanForFrequency(newFrequency, item);

  if (targetVariant && targetVariant.id !== item.variant_id) {
    // Use complete subscription upgrade to ensure both variant and plan are synced
    completeSubscriptionFrequencyChange(item, targetVariant, newFrequency, newSellingPlan);
  } else {
    // Prepare updated properties
    const updatedProperties = { ...item.properties };
    delete updatedProperties._otp; // Ensure no OTP flag for subscriptions
    if (frequencyNumber) {
      updatedProperties._months = frequencyNumber.toString();
    }

    // Update both properties and selling plan in one operation
    const updateData = {
      properties: updatedProperties
    };

    if (newSellingPlan?.id) {
      updateData.selling_plan = newSellingPlan.id;
    }

    window.Rebuy.Cart.changeItem(item, updateData, function(success) {
      // Update product object to reflect new frequency
      if (item.product) {
        item.product.subscription_frequency = newFrequency;
      }

      // Clear updating status
      item.status = null;

    }, function(error) {
      console.error('❌ Failed to update frequency and selling plan:', error);

      // Fallback: try native frequency change
      window.Rebuy.Cart.switchItemToFrequency(item, newFrequency, function(success) {
        // Still update properties manually
        updateItemProperties(item, newFrequency, frequencyNumber);
        item.status = null;

      }, function(nativeError) {
        console.error('❌ Native frequency change also failed:', nativeError);
        item.status = null;
      });
    });
  }
}

// Complete subscription frequency change with variant swap
function completeSubscriptionFrequencyChange(currentItem, targetVariant, newFrequency, newSellingPlan) {
  currentItem.status = 'upgrading';
  window.cartStatus.set('swap');
  const targetMonths = getMonthsFromFrequency(newFrequency, currentItem);
  const updatedProperties = { ...currentItem.properties };

  if (newFrequency === 'onetime') {
    // For one-time purchase
    updatedProperties._otp = 'true';
    // Remove _months property for OTP items
    delete updatedProperties._months;
  } else {
    // For subscription
    delete updatedProperties._otp;
    if (targetMonths) {
      updatedProperties._months = targetMonths.toString();
    }
  }


  console.log(currentItem, 'completeSubscriptionFrequencyChange');
  // Remove the current item
  window.Rebuy.Cart.removeItem(currentItem, function() {
    const newItemData = {
      id: targetVariant.id,
      quantity: currentItem.quantity,
      properties: updatedProperties
    };

    // Add selling plan for new frequency
    if (newSellingPlan?.id) {
      newItemData.selling_plan = newSellingPlan.id;
    }

    window.Rebuy.Cart.addItem(newItemData, {
      success: function(response) {
        // Fetch updated cart to get the new item reference
        window.cartStatus.clear();
        window.Rebuy.Cart.fetchShopifyCart(function(cart) {
          const addedItem = cart.items.find(item =>
            item.variant_id === targetVariant.id &&
            item.properties?._months === targetMonths?.toString()
          );

          if (addedItem) {
            // Ensure product object reflects new subscription frequency
            if (addedItem.product) {
              addedItem.product.subscription = true;
              addedItem.product.subscription_frequency = newFrequency;
            }
          }
        });
      },
      error: function(error) {
        console.error('❌ Failed to add item with new frequency:', error);

        // Re-add original item as last resort
        window.Rebuy.Cart.addItem({
          id: currentItem.variant_id,
          quantity: currentItem.quantity,
          selling_plan: currentItem.selling_plan,
          properties: currentItem.properties
        }, {
          success: function() {
            currentItem.status = null;
            window.cartStatus.clear();
          },
          error: function(restoreError) {
            console.error('❌ Failed to restore original item:', restoreError);
            currentItem.status = null;
            window.cartStatus.clear();
          }
        });
      }
    });
  }, function(removeError) {
    console.error('❌ Failed to remove original item for frequency change:', removeError);
    currentItem.status = null;
  });
}

// Legacy function - keeping for compatibility but now delegates to new handlers
function upgradeOTPToSubscription(currentItem, newVariant, newFrequency) {
  currentItem.status = 'upgrading';
  window.cartStatus.set('swap');
  const SmartCart = window.Rebuy?.SmartCart;

  // Check if item supports subscription switching
  if (SmartCart && !SmartCart.hasSwitchToSubscription(currentItem)) {
    return;
  }

  // Get selling plan for the new frequency
  const newSellingPlan = getSellingPlanForFrequency(newFrequency, currentItem);

  // Calculate months for the new frequency
  const monthsFromFrequency = getMonthsFromFrequency(newFrequency, currentItem);

  // If we need to change variants, do the swap first
  if (newVariant.id !== currentItem.variant_id) {
    swapVariantAndFrequency(currentItem, newVariant, newFrequency);
    return;
  }

  // Update the item's product object to prepare for subscription
  if (currentItem.product) {
    currentItem.product.subscription = true;
    currentItem.product.subscription_frequency = newFrequency;

    // Update _months property and remove _otp
    const updatedProperties = { ...currentItem.properties };
    delete updatedProperties._otp;
    if (monthsFromFrequency) {
      updatedProperties._months = monthsFromFrequency.toString();
    }

    // Update item properties first

    window.Rebuy.Cart.changeItem(currentItem, {
      properties: updatedProperties
    }, function(success) {
      // Create and dispatch the Rebuy subscription switch event
      const subscriptionEvent = new CustomEvent('rebuy:smartcart.item-switch-to-subscription', {
        detail: {
          item: currentItem,
          frequency: newFrequency,
          sellingPlan: newSellingPlan?.id,
          months: monthsFromFrequency
        },
        bubbles: true
      });

      document.dispatchEvent(subscriptionEvent);

    }, function(error) {
      console.error('❌ Failed to update properties for subscription:', error);

      // Fallback: still try to trigger the subscription event
      const subscriptionEvent = new CustomEvent('rebuy:smartcart.item-switch-to-subscription', {
        detail: {
          item: currentItem,
          frequency: newFrequency,
          sellingPlan: newSellingPlan?.id,
          months: monthsFromFrequency
        },
        bubbles: true
      });

      document.dispatchEvent(subscriptionEvent);
    });
  } else {
    console.error('❌ Item does not have product object for subscription upgrade');
  }
}

// Update item properties for frequency changes without variant swap
function updateItemProperties(item, newFrequency, frequencyNumber) {

  const updatedProperties = { ...item.properties };

  if (newFrequency === 'onetime') {
    // For one-time purchase
    updatedProperties._otp = 'true';
    // Remove _months property for OTP items
    delete updatedProperties._months;
  } else {
    // For subscription
    delete updatedProperties._otp;
    if (frequencyNumber) {
      updatedProperties._months = frequencyNumber.toString();
    }
  }

  // Update the item properties using Rebuy's changeItem method
  window.Rebuy.Cart.changeItem(item, {
    properties: updatedProperties
  }, function(success) {
    // Success - no logging needed
  }, function(error) {
    console.error('❌ Failed to update properties:', error);
  });
}

// Convert selling plan frequency to months and get selling plan ID
function getMonthsFromFrequency(frequency, item) {
  // Handle onetime case
  if (frequency === 'onetime') {
    return 1;
  }

  // If frequency is a selling plan ID, find the associated months
  if (typeof frequency === 'string') {
    const sellingPlan = findSellingPlanById(frequency, item);
    if (sellingPlan) {
      const months = extractMonthsFromSellingPlan(sellingPlan);
      return months;
    }
  }

  // If frequency is a number (legacy), convert it
  if (typeof frequency === 'number') {
    const months = Math.round(frequency / 30); // Convert days to months
    return months;
  }

  // Default fallback for subscriptions
  return 1;
}

// Find selling plan by ID or name in product's selling plan groups
function findSellingPlanById(planIdOrName, item) {
  if (!item.product?.selling_plan_groups) {
    return null;
  }

  for (const group of item.product.selling_plan_groups) {
    if (group.selling_plans) {
      // First try to match by ID
      let plan = group.selling_plans.find(plan =>
        plan.id.toString() === planIdOrName.toString()
      );

      // If not found by ID, try to match by name
      if (!plan) {
        plan = group.selling_plans.find(plan =>
          plan.name === planIdOrName ||
          plan.name?.toLowerCase() === planIdOrName.toLowerCase()
        );
      }

      // If still not found, try partial name matching for patterns like "1 month subscription"
      if (!plan) {
        plan = group.selling_plans.find(plan => {
          const planName = plan.name?.toLowerCase() || '';
          const searchName = planIdOrName.toLowerCase();

          // Match patterns like "1 month subscription" with "1 month subscription with 10% discount"
          if (searchName.includes('month subscription')) {
            return planName.includes('month subscription') &&
              extractMonthsFromSellingPlan(plan) === extractMonthsFromSearchTerm(searchName);
          }

          return false;
        });
      }

      if (plan) {
        return plan;
      }
    }
  }

  return null;
}

// Extract months from search term like "1 month subscription with 10% discount"
function extractMonthsFromSearchTerm(searchTerm) {
  const monthMatch = searchTerm.match(/(\d+)\s*month/i);
  return monthMatch ? parseInt(monthMatch[1]) : null;
}

// Find the selling plan with the biggest number in its name
function findSellingPlanWithBiggestNumber(product) {
  if (!product?.selling_plan_groups) {
    return null;
  }

  let bestSellingPlan = null;
  let highestNumber = 0;

  for (const group of product.selling_plan_groups) {
    if (group.selling_plans) {
      for (const plan of group.selling_plans) {
        // Extract all numbers from the selling plan name
        const numbers = plan.name?.match(/(\d+)/g);
        if (numbers) {
          // Find the highest number in the name
          const maxNumber = Math.max(...numbers.map(n => parseInt(n)));
          if (maxNumber > highestNumber) {
            highestNumber = maxNumber;
            bestSellingPlan = plan;
          }
        }
      }
    }
  }

  return bestSellingPlan;
}

// Helper function to log all available selling plans and variants (for debugging)
function logAllSellingPlans(item) {
  // This function is kept for potential debugging but logs are removed in production
  return;
}

// Extract months from selling plan name or billing policy
function extractMonthsFromSellingPlan(sellingPlan) {
  // Try to extract from selling plan name (e.g., "Delivery every 2 months")
  const nameMatch = sellingPlan.name?.match(/(\d+)\s*month/i);
  if (nameMatch) {
    return parseInt(nameMatch[1]);
  }

  // Try to extract from billing policy frequency
  if (sellingPlan.billing_policy?.interval_count &&
    sellingPlan.billing_policy?.interval === 'month') {
    return sellingPlan.billing_policy.interval_count;
  }

  // Try to extract from delivery policy frequency
  if (sellingPlan.delivery_policy?.interval_count &&
    sellingPlan.delivery_policy?.interval === 'month') {
    return sellingPlan.delivery_policy.interval_count;
  }

  // Fallback: try to extract number from name
  const numberMatch = sellingPlan.name?.match(/(\d+)/);
  if (numberMatch) {
    return parseInt(numberMatch[1]);
  }

  return null;
}

// Get selling plan object for frequency (reverse lookup)
function getSellingPlanForFrequency(frequency, item) {
  if (frequency === 'onetime') {
    return null;
  }

  if (!item.product?.selling_plan_groups) {
    return null;
  }

  // If frequency is a string (could be selling plan ID or name), find that plan
  if (typeof frequency === 'string') {
    const plan = findSellingPlanById(frequency, item);
    if (plan) {
      return plan;
    }
  }

  // If frequency is a number (legacy), find matching selling plan
  let targetMonths = null;
  if (typeof frequency === 'number') {
    targetMonths = Math.round(frequency / 30); // Convert days to months
  } else {
    // For string frequencies, try to extract numbers directly
    const numMatch = frequency.toString().match(/(\d+)/);
    if (numMatch) {
      targetMonths = parseInt(numMatch[1]);
    }
  }

  if (targetMonths) {
    for (const group of item.product.selling_plan_groups) {
      if (group.selling_plans) {
        const plan = group.selling_plans.find(plan => {
          const planMonths = extractMonthsFromSellingPlan(plan);
          return planMonths === targetMonths;
        });
        if (plan) {
          return plan;
        }
      }
    }
  }

  // Fallback: return first available selling plan
  for (const group of item.product.selling_plan_groups) {
    if (group.selling_plans && group.selling_plans.length > 0) {
      const fallbackPlan = group.selling_plans[0];
      return fallbackPlan;
    }
  }

  return null;
}

// Find subscription variant with specific bottle count/months
function findSubscriptionVariant(product, months) {
  if (!product.variants) {
    return null;
  }

  const subscriptionVariant = product.variants.find(variant => {
    const title = variant.title.toLowerCase();

    // Skip obvious OTP variants
    if (title.includes('one time') ||
      title.includes('onetime') ||
      title.includes('one-time') ||
      title.includes('single purchase') ||
      title.includes('buy once')) {
      return false;
    }

    // Look for subscription language WITH bottle count
    const bottleMatch = title.match(/(\d+)\s*bottle/);
    if (bottleMatch && parseInt(bottleMatch[1]) === months) {
      // Prefer variants with subscription language
      if (title.includes('subscription') ||
        title.includes('ships every') ||
        title.includes('delivery every') ||
        title.includes('month') ||
        title.includes('auto-renew')) {
        return true;
      }

      // Also accept variants with bottle count that aren't explicitly OTP
      return true;
    }

    return false;
  });

  return subscriptionVariant;
}

// Find highest tier subscription variant (subscription language + highest bottle count)
function findHighestTierSubscriptionVariant(product) {
  if (!product.variants) {
    return null;
  }

  let highestSubscriptionVariant = null;
  let highestCount = 0;

  product.variants.forEach((variant, index) => {
    const title = variant.title.toLowerCase();

    // Skip obvious OTP variants
    if (title.includes('one time') ||
      title.includes('onetime') ||
      title.includes('one-time') ||
      title.includes('single purchase') ||
      title.includes('buy once')) {
      return;
    }

    // Look for bottle count
    const bottleMatch = title.match(/(\d+)\s*bottle/);
    if (bottleMatch) {
      const bottleCount = parseInt(bottleMatch[1]);

      // Prefer variants with subscription language
      const hasSubscriptionLanguage = title.includes('subscription') ||
        title.includes('ships every') ||
        title.includes('delivery every') ||
        title.includes('month') ||
        title.includes('auto-renew');

      if (bottleCount > highestCount && (hasSubscriptionLanguage || !title.includes('time purchase'))) {
        highestCount = bottleCount;
        highestSubscriptionVariant = variant;
      }
    }
  });

  return highestSubscriptionVariant;
}

// Find the basic OTP variant - typically the simplest single purchase option
function findBasicOTPVariant(product) {
  if (!product.variants) {
    return null;
  }

  // Priority 1: Look for variants explicitly labeled as one-time purchase
  let otpVariant = product.variants.find(variant => {
    const title = variant.title.toLowerCase();

    // Look for explicit one-time purchase language only
    if (title.includes('one time') ||
      title.includes('onetime') ||
      title.includes('one-time') ||
      title.includes('single purchase') ||
      title.includes('buy once')) {
      return true;
    }

    return false;
  });

  // Priority 2: Look for the simplest variant (no subscription language)
  if (!otpVariant) {
    otpVariant = product.variants.find(variant => {
      const title = variant.title.toLowerCase();

      // Avoid subscription-specific language
      if (title.includes('subscription') ||
        title.includes('auto-renew') ||
        title.includes('recurring') ||
        title.includes('ships every') ||
        title.includes('month subscription') ||
        title.includes('delivery every')) {
        return false;
      }

      // Prefer variants with simple titles (no bottle count or subscription language)
      if (title === 'default title' || !title.includes('bottle')) {
        return true;
      }

      return false;
    });
  }

  // Priority 3: Fallback to first variant that doesn't have subscription language
  if (!otpVariant) {
    otpVariant = product.variants.find(variant => {
      const title = variant.title.toLowerCase();

      // Just avoid obvious subscription language
      if (!title.includes('subscription') &&
        !title.includes('ships every') &&
        !title.includes('delivery every')) {
        return true;
      }

      return false;
    });
  }

  // Priority 4: Last resort - use first variant
  if (!otpVariant && product.variants.length > 0) {
    otpVariant = product.variants[0];
  }

  return otpVariant;
}

// Find the highest tier variant (highest bottle count)
function findHighestTierVariant(product) {
  if (!product.variants) {
    return null;
  }

  let highestVariant = null;
  let highestCount = 0;

  product.variants.forEach((variant, index) => {
    const title = variant.title.toLowerCase();

    // Match pattern like "2 bottles" or "3 bottles" or "1 bottle"
    const bottleMatch = title.match(/(\d+)\s*bottle/);
    if (bottleMatch) {
      const bottleCount = parseInt(bottleMatch[1]);

      if (bottleCount > highestCount) {
        highestCount = bottleCount;
        highestVariant = variant;
      }
    }
  });

  return highestVariant;
}

// Find variant that matches bottle count (frequency in months)
function findVariantByBottleCount(product, months) {
  if (!product.variants) {
    return null;
  }

  const matchingVariant = product.variants.find(variant => {
    const title = variant.title.toLowerCase();

    // Match pattern like "2 bottles" or "3 bottles" or "1 bottle"
    const bottleMatch = title.match(/(\d+)\s*bottle/);
    if (bottleMatch) {
      const bottleCount = parseInt(bottleMatch[1]);
      return bottleCount === months;
    }

    // Alternative patterns for monthly subscriptions
    if (months === 1) {
      // Match "ships monthly" or "monthly" for 1 month frequency
      if (title.includes('monthly') || title.includes('month')) {
        return true;
      }
    }

    return false;
  });

  return matchingVariant;
}

// Flexible variant matching - tries multiple approaches
function findVariantFlexible(product, months, frequency) {
  if (!product.variants) {
    return null;
  }

  const isOTP = frequency === 'onetime';

  return product.variants.find(variant => {
    const title = variant.title.toLowerCase();

    // For OTP items, prioritize variants without subscription-specific language
    if (isOTP) {
      // Avoid subscription language for OTP
      if (title.includes('subscription') || title.includes('auto-renew') || title.includes('recurring')) {
        return false;
      }

      // Look for bottle count first
      const bottleMatch = title.match(/(\d+)\s*bottle/);
      if (bottleMatch && parseInt(bottleMatch[1]) === months) {
        return true;
      }

      // For 1 month OTP, accept variants without explicit subscription language
      if (months === 1) {
        // Accept simple titles like "Product Name" or "1 bottle"
        if (!title.includes('month') || title.includes('1 bottle')) {
          return true;
        }
      }
    }

    // For subscription frequency changes
    if (!isOTP) {
      // For 1 month, try multiple patterns
      if (months === 1) {
        // Pattern 1: "1 bottle"
        if (title.includes('1 bottle')) {
          return true;
        }

        // Pattern 2: "monthly" or "month"
        if (title.includes('monthly') || title.includes('month')) {
          return true;
        }

        // Pattern 3: "ships every 1" or similar
        if (title.includes('ships every 1') || title.includes('every 1')) {
          return true;
        }
      }

      // For other months, try bottle count and "every X months"
      if (months > 1) {
        // Try bottle count
        const bottleMatch = title.match(/(\d+)\s*bottle/);
        if (bottleMatch && parseInt(bottleMatch[1]) === months) {
          return true;
        }

        // Try "every X months" pattern
        const monthPattern = title.match(/every\s*(\d+)\s*month/);
        if (monthPattern && parseInt(monthPattern[1]) === months) {
          return true;
        }
      }
    }

    return false;
  });
}

// Alternative approach: Find variant by selling plan allocation
function findVariantBySellingPlan(product, sellingPlanId) {
  if (!product.variants) {
    return null;
  }

  const matchingVariant = product.variants.find(variant => {
    if (variant.selling_plan_allocations) {
      const hasMatchingPlan = variant.selling_plan_allocations.some(allocation =>
        allocation.selling_plan_id?.toString() === sellingPlanId.toString()
      );
      return hasMatchingPlan;
    }
    return false;
  });

  return matchingVariant;
}

// Swap variant and update frequency using Rebuy methods
function swapVariantAndFrequency(currentItem, newVariant, newFrequency) {
  // For variant changes, use the remove+add approach directly as it's more reliable
  // window.Rebuy.Cart.changeItem is mainly for quantity/properties, not variants
  fallbackVariantSwap(currentItem, newVariant, newFrequency);
}

// Fallback method: remove current item and add new variant
function fallbackVariantSwap(currentItem, newVariant, newFrequency) {

  const isOTP = newFrequency === 'onetime';

  // Get selling plan for the new frequency (only for subscriptions)
  const newSellingPlan = isOTP ? null : getSellingPlanForFrequency(newFrequency, currentItem);

  // Calculate months for the new frequency
  const monthsFromFrequency = getMonthsFromFrequency(newFrequency, currentItem);

  // Prepare updated properties
  const updatedProperties = {
    ...currentItem.properties
  };

  // Update _months and _otp properties based on the new frequency
  if (isOTP) {
    // For one-time purchase - set _otp flag and remove _months
    updatedProperties._otp = 'true';
    delete updatedProperties._months;  // Remove _months for OTP items
    console.log('Updating OTP item properties...', updatedProperties);
  } else {
    // For subscription
    delete updatedProperties._otp; // Remove OTP flag for subscriptions
    if (monthsFromFrequency) {
      updatedProperties._months = monthsFromFrequency.toString();
    }
  }

  window.Rebuy.Cart.removeItem(currentItem, function() {
    const newItemData = {
      id: newVariant.id,
      quantity: currentItem.quantity,
      properties: updatedProperties
    };

    // Only add selling plan for subscriptions, NOT for OTP items
    if (!isOTP && newSellingPlan?.id) {
      newItemData.selling_plan = newSellingPlan.id;
    }

    window.Rebuy.Cart.addItem(newItemData, {
      success: function(response) {
        // Only set subscription frequency for non-OTP items
        window.CartStatus.set('ready');
        if (!isOTP) {
          window.Rebuy.Cart.fetchShopifyCart(function(cart) {
            const addedItem = cart.items.find(item =>
              item.variant_id === newVariant.id && !item.properties?._otp
            );

            if (addedItem && newSellingPlan) {
              window.Rebuy.Cart.switchItemToFrequency(addedItem, newFrequency, function(success) {
                // Success - no logging needed
              }, function(error) {
                console.error('❌ Failed to set frequency on new item:', error);
              });
            }
          });
        }
      },
      error: function(error) {
        console.error('❌ Failed to add new variant:', error);

        // Re-add original item as last resort
        window.Rebuy.Cart.addItem({
          id: currentItem.variant_id,
          quantity: currentItem.quantity,
          selling_plan: currentItem.selling_plan,
          properties: currentItem.properties
        }, {
          success: function() {
            // Success - no logging needed
          },
          error: function(restoreError) {
            console.error('❌ Failed to restore original item:', restoreError);
          }
        });
      }
    });
  });
}